import React from 'react';
import { Modal } from 'antd';
import Single from './Single';
import Icon from '../Icon';
import { bodyScrollFix } from '../../utils';

export default ({ visible, onOk, initialItem, onAddToCart, ...rest }) => (
  <Modal
    title={null}
    footer={null}
    open={visible}
    wrapClassName={'order'}
    width="100%"
    closeIcon={<Icon name="close" />}
    centered
    {...rest}
    afterClose={bodyScrollFix}
  >
    <Single initialItemId={initialItem} />
  </Modal>
);
